import {E_GenereOmbrellone} from "./enumerations";

var ombrelloniState = {
    braccio: {},
    centrale: {},
    sbalzo: {}
};

// Salva in memoria e carica le configurazioni degli ombrelloni quando si cambia il genere di ombrellone e i relativi menù UI
// Salva lo stato
export const saveOmbrelloniState = (genereOmbrellone, newState) => {
    if (genereOmbrellone.toString() === E_GenereOmbrellone.Braccio.toString()) {
        ombrelloniState.braccio = newState;        
    } else if (genereOmbrellone.toString() === E_GenereOmbrellone.Centrale.toString()) {
        ombrelloniState.centrale = newState;      
    } else if (genereOmbrellone.toString() === E_GenereOmbrellone.Sbalzo.toString()) {
        ombrelloniState.sbalzo = newState;
    }
}
// Carica lo stato
export const loadOmbrelloniState = (genereOmbrellone) => {
    if (genereOmbrellone.toString() === E_GenereOmbrellone.Braccio.toString()) {
        return ombrelloniState.braccio;
    } else if (genereOmbrellone.toString() === E_GenereOmbrellone.Centrale.toString()) {
        return ombrelloniState.centrale;
    } else if (genereOmbrellone.toString() === E_GenereOmbrellone.Sbalzo.toString()) {
        return ombrelloniState.sbalzo;
    }  
}
// Cancella lo stato
export const deleteOmbrelloniState = () => {
    ombrelloniState = {
        braccio: {},
        centrale: {},
        sbalzo: {}
    };
}